import { MonthNameType } from '../../../../BKJCalendar/src/BKJCalendar.types';

export const monthsArray: Array<MonthNameType> = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
